var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Vue Uploader")]),_vm._v(" "),_c('div',{staticClass:"image-wrap"},[_c('image_modal',{attrs:{"input_name":"image_tag","exist_image":_vm.existImage,"set_ratio":"2.2"}})],1),_vm._v(" "),_c('p',[_vm._v("click image")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1882fc1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = jpCs
// module chunks = 1